import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Input } from '../../../components/forms';
import { Modal, Grid, Box, MenuItem, Popover, Tooltip, TextField, Snackbar } from '@material-ui/core';
import Button from '../../../components/common/Button';
import TableSite from '../../../components/common/Table';
import Alert from '../../../components/common/Alert';
import SessionAPI from '../session-api';
import { Form, Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from '../../../app/AppContext';
import { formatDate } from '../../../utils/format';
import { SITES, statusSession } from '../../../utils/constants';
import Menu, { MenuContainer } from '../../../components/common/Menu';
import InvitationModal from '../../../components/common/Modal/InvitationModal';
import AnnouncementModal from '../../AnnouncementContainer/AnnouncementInfoContainer/reschedule-announcement';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
import ScheduleSharpIcon from '@material-ui/icons/ScheduleSharp';
import EditableCell from '../../../components/common/TableEncuesta/EditableCell';
import SessionsDashboard from '../SessionsDashboard';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import Spinner from '../../../components/common/Spinner';
import { ATTENDANCE_STATUS, getAttendanceDetails } from './attendance';

const RESCHEDULABLE_STATUSES = [
  'created',
  'not-assigned',
  'active',
  'rescheduled',
  'no-email',
];

const ATTENDANCE_COLORS = {
  [ATTENDANCE_STATUS.ACCEPTED]: '#2e7d32',
  [ATTENDANCE_STATUS.DECLINED]: '#c62828',
  [ATTENDANCE_STATUS.PENDING]: '#ed6c02',
};

const AttendanceIndicator = ({ user }) => {
  const attendance = getAttendanceDetails(user);
  const color = ATTENDANCE_COLORS[attendance.status];
  const Icon =
    attendance.status === ATTENDANCE_STATUS.ACCEPTED
      ? CheckCircleSharpIcon
      : attendance.status === ATTENDANCE_STATUS.DECLINED
      ? CancelSharpIcon
      : ScheduleSharpIcon;

  return (
    <Tooltip title={attendance.tooltip}>
      <div
        aria-label={attendance.tooltip}
        style={{ display: 'flex', alignItems: 'center', color, marginLeft: 8 }}
      >
        <Icon fontSize="small" />
        <div style={{ marginLeft: 4, lineHeight: 1.1, whiteSpace: 'nowrap' }}>
          <div style={{ fontSize: 12 }}>{attendance.statusLabel}</div>
          {attendance.sourceLabel && (
            <div style={{ color: '#616161', fontSize: 10 }}>
              {attendance.sourceLabel}
            </div>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0 none',
  },
  paper: {
    backgroundColor: 'white',
    border: '0 none',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const SessionTableContainer = () => {
  const allStatus = [
    'created',
    'not-assigned',
    'active',
    'rescheduled',
    'finished',
    'canceled',
    'not-used',
    'abandoned',
  ];
  const history = useHistory();
  const statusEl = useRef();
  const {
    user: { role },
    roles: { roles },
  } = useContext(AppContext);
  const roleDefinitions = Array.isArray(roles) ? roles : [];
  const isMountedRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const clientSnackbarTimerRef = useRef(null);
  const [openModal, setSOpenModal] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [typeMessage, setTypeMessage] = useState('info');
  const [idSession, setIdSession] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [status, setStatus] = useState(allStatus);
  const [isMenuOpen, setIsMenuOpen] = useState({ id: null, open: false });
  const [isInvitationModalOpen, setIsInvitationModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isRescheduleLoading, setIsRescheduleLoading] = useState(false);
  const [sessionToReschedule, setSessionToReschedule] = useState(null);
  const [allSessions, setAllSessions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [clients, setClients] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [reloadFlag, setReloadFlag] = useState(0);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 25;
  const [isClientSnackbarOpen, setIsClientSnackbarOpen] = useState(false);
  const [clientSnackbarMessage, setClientSnackbarMessage] = useState('');
  const [optionsStatus] = useState([
    { value: 'created', label: 'Creada' },
    // { value: 'not-assigned', label: 'No asignada' },
    { value: 'active', label: 'Activa' },
    { value: 'rescheduled', label: 'Reagendada' },
    { value: 'finished', label: 'Finalizada' },
    { value: 'canceled', label: 'Cancelada' },
    { value: 'not-used', label: 'No usada' },
    { value: 'abandoned', label: 'Abandonada' },
  ])
  const selectedClientId =
    selectedClient && Number.isFinite(Number(selectedClient.id))
      ? Number(selectedClient.id)
      : null;
  const selectedAnnouncementId =
    selectedAnnouncement && Number.isFinite(Number(selectedAnnouncement.id))
      ? Number(selectedAnnouncement.id)
      : null;
  const clearClientSnackbarTimer = useCallback(() => {
    if (clientSnackbarTimerRef.current) {
      clearTimeout(clientSnackbarTimerRef.current);
      clientSnackbarTimerRef.current = null;
    }
  }, []);

  const handleCloseClientSnackbar = useCallback((event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    clearClientSnackbarTimer();
    setIsClientSnackbarOpen(false);
    setClientSnackbarMessage('');
  }, [clearClientSnackbarTimer]);

  const showClientSnackbar = useCallback((text) => {
    clearClientSnackbarTimer();
    setClientSnackbarMessage(text);
    setIsClientSnackbarOpen(true);
    clientSnackbarTimerRef.current = setTimeout(() => {
      setIsClientSnackbarOpen(false);
      clientSnackbarTimerRef.current = null;
    }, 4000);
  }, [clearClientSnackbarTimer]);

  setTimeout(function () {
    setMessage('');
  }, 5000);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      clearClientSnackbarTimer();
    };
  }, []);

  useEffect(() => {
    if (!isMountedRef.current) {
      return;
    }

    setSessions(() => {
      if (status.length === 1) {
        return (allSessions || []).filter((session) => {
          return session.status === status[0];
        });
      }

      return allSessions;
    });
  }, [allSessions, status]);

  useEffect(() => {
    let isActive = true;

    const fetchSessionsData = async () => {
      setIsLoading(true);
      try {
        const params = {};
        if (searchTerm) {
          params.search = searchTerm;
        }
        params.page = currentPage;
        params.pageSize = pageSize;
        if (selectedClientId !== null) {
          params.clientId = selectedClientId;
        }
        if (selectedAnnouncementId !== null) {
          params.announcementId = selectedAnnouncementId;
        }

        const response = await SessionAPI.getSessions(params);
        const fetchedSessions = response?.data?.sessions || [];
        const fetchedClients = response?.data?.clients || [];
        const fetchedAnnouncements = response?.data?.announcements || [];
        const fetchedTotalPages = Number(response?.data?.totalPages);
        const responsePage = Number(response?.data?.page);

        if (isMountedRef.current && isActive) {
          const shouldPreserveSelections = Boolean(searchTerm);
          setAllSessions(fetchedSessions);
          setTotalPages(
            Number.isFinite(fetchedTotalPages) ? Math.max(fetchedTotalPages, 0) : 1
          );
          if (Number.isFinite(responsePage) && responsePage > 0) {
            setCurrentPage(responsePage);
          }
          setClients((prevClients) => {
            if (shouldPreserveSelections && fetchedClients.length === 0) {
              return prevClients;
            }
            return fetchedClients;
          });

          if (selectedClientId !== null) {
            setAnnouncements((prevAnnouncements) => {
              if (shouldPreserveSelections && fetchedAnnouncements.length === 0) {
                return prevAnnouncements;
              }
              return fetchedAnnouncements;
            });
            if (!shouldPreserveSelections && fetchedAnnouncements.length === 0) {
              showClientSnackbar('No se encontraron programas para el cliente seleccionado.');
            } else if (fetchedAnnouncements.length > 0) {
              clearClientSnackbarTimer();
              setIsClientSnackbarOpen(false);
              setClientSnackbarMessage('');
            }
          } else {
            setAnnouncements([]);
            clearClientSnackbarTimer();
            setIsClientSnackbarOpen(false);
            setClientSnackbarMessage('');
          }

          if (
            selectedClientId !== null &&
            !fetchedClients.some((client) => client.id === selectedClientId)
          ) {
            if (!shouldPreserveSelections) {
              setSelectedClient(null);
              setSelectedAnnouncement(null);
              setAnnouncements([]);
            }
          } else if (
            selectedAnnouncementId !== null &&
            !fetchedAnnouncements.some(
              (announcement) => announcement.id === selectedAnnouncementId
            )
          ) {
            if (!shouldPreserveSelections) {
              setSelectedAnnouncement(null);
            }
          }
        }
      } catch (error) {
        if (isMountedRef.current && isActive) {
          setMessage('Error al cargar las reuniones.');
          setTypeMessage('error');
        }
      } finally {
        if (isMountedRef.current && isActive) {
          setIsLoading(false);
        }
      }
    };

    fetchSessionsData();

    return () => {
      isActive = false;
    };
  }, [searchTerm, selectedClientId, selectedAnnouncementId, showClientSnackbar, clearClientSnackbarTimer, reloadFlag, currentPage]);

  const handleClientChange = (event, newClient) => {
    setSelectedClient(newClient);
    setSelectedAnnouncement(null);
    setAnnouncements([]);
    setCurrentPage(1);
    clearClientSnackbarTimer();
    setIsClientSnackbarOpen(false);
    setClientSnackbarMessage('');
  };

  const handleAnnouncementChange = (event, newAnnouncement) => {
    setSelectedAnnouncement(newAnnouncement);
    setCurrentPage(1);
  };

  const handleCancelSession = (values) => {
    setIsSubmitting(true);
    SessionAPI.cancelSession(idSession, values)
      .then((response) => {
        setIsSubmitting(false);
        setAllSessions((prevSessions) => {
          if (!prevSessions || prevSessions.length === 0) {
            return prevSessions;
          }

          const updatedSessions = [];
          prevSessions.forEach((session) => {
            if (session.id === idSession) {
              updatedSessions.unshift({ ...session, status: 'canceled' });
            } else {
              updatedSessions.push(session);
            }
          });

          return updatedSessions;
        });
        setMessage(response.data.message);
        setTypeMessage('success');
        setSOpenModal(false);
      })
      .catch((e) => {
        setSOpenModal(false);
        setIsSubmitting(false);
        setMessage(e?.data?.message);
        setTypeMessage('error');
      });
  };

  const handleSearchSessions = (event) => {
    const { value = '' } = event?.target || {};
    const normalizedValue = value.trim();

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      if (!isMountedRef.current) {
        return;
      }

      setSearchTerm((prev) => {
        if (prev === normalizedValue) {
          return prev;
        }
        setCurrentPage(1);
        return normalizedValue;
      });
    }, 400);
  };

  const handleSetSessions = (updatedSessions) => {
    setSessions(updatedSessions);

    setAllSessions((prevSessions) => {
      if (!prevSessions || prevSessions.length === 0) {
        return prevSessions;
      }

      if (!updatedSessions || updatedSessions.length === 0) {
        return prevSessions;
      }

      const sessionsById = new Map(
        updatedSessions
          .filter((session) => session && session.id)
          .map((session) => [session.id, session])
      );

      if (sessionsById.size === 0) {
        return prevSessions;
      }

      return prevSessions.map((session) => {
        if (sessionsById.has(session.id)) {
          return sessionsById.get(session.id);
        }
        return session;
      });
    });
  };

  const getRoleTypeById = (roleId) => {
    const numericRoleId = Number(roleId);
    if (!Number.isFinite(numericRoleId)) {
      return null;
    }

    const roleFound = roleDefinitions.find((tempRole) => {
      return Number(tempRole.id) === numericRoleId;
    });

    return roleFound?.type || null;
  };

  const resolveUserRoleType = (user) => {
    if (!user) {
      return null;
    }

    const { role: userRole } = user;

    if (typeof userRole === 'string') {
      if (userRole === 'mentee' || userRole === 'mentor') {
        return userRole;
      }
      return getRoleTypeById(userRole);
    }

    if (typeof userRole === 'number') {
      return getRoleTypeById(userRole);
    }

    if (userRole && typeof userRole === 'object') {
      if (typeof userRole.type === 'string') {
        return userRole.type;
      }
      if (userRole.id !== undefined && userRole.id !== null) {
        return getRoleTypeById(userRole.id);
      }
    }

    return null;
  };

  const getUserId = (user) => {
    if (!user) {
      return null;
    }
    return user.id ?? user.user?.id ?? user.userId ?? null;
  };

  const getUserByRoleStrict = (users, roleType) => {
    if (!Array.isArray(users) || users.length === 0) {
      return null;
    }

    return (
      users.find((userTemp) => {
        return resolveUserRoleType(userTemp) === roleType;
      }) || null
    );
  };

  const getUserByRole = (users, roleType) => {
    if (!Array.isArray(users) || users.length === 0) {
      return null;
    }

    const strictMatch = getUserByRoleStrict(users, roleType);
    if (strictMatch) {
      return strictMatch;
    }

    // Fallback para sesiones históricas con rol "no estándar" (ej. role=4).
    // Si existe el contraparte (mentor/mentee), usamos el otro usuario.
    const counterpartRole = roleType === 'mentor' ? 'mentee' : 'mentor';
    const counterpartUser = getUserByRoleStrict(users, counterpartRole);
    if (counterpartUser) {
      const counterpartUserId = getUserId(counterpartUser);
      const counterpartNumericId = Number(counterpartUserId);

      const fallbackUser = users.find((userTemp) => {
        const userId = getUserId(userTemp);
        const numericUserId = Number(userId);

        if (
          Number.isFinite(counterpartNumericId) &&
          Number.isFinite(numericUserId) &&
          numericUserId === counterpartNumericId
        ) {
          return false;
        }

        return resolveUserRoleType(userTemp) !== 'admin';
      });

      if (fallbackUser) {
        return fallbackUser;
      }
    }

    return users[0] || null;
  };

  const showUser = (users, roleType) => {
    const user = getUserByRole(users, roleType);
    return user?.name || user?.user?.name || '-';
  };

  const getRefererUser = (users, roleType) => {
    const user = getUserByRole(users || [], roleType);

    if (!user) {
      return '-';
    }

    const { announcement } = user;

    if (announcement) {
      return (
        announcement.title ||
        announcement.name ||
        '-'
      );
    }

    return '-';
  };

  const url =
    window.location.origin === SITES.PROD.admin
      ? SITES.PROD.platform
      : SITES.DEV.platform;
  const classes = useStyles();

  const onClick = (id) => {
    setIsMenuOpen((prevState) => ({
      id,
      open: prevState.id !== id || !prevState.open,
    }));
  };

  const copyTextToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setMessage('Link copiado al portapapeles');
    setTypeMessage('success');
  };

  const buildStartDateTime = (availableDate, hour) => {
    if (!availableDate || hour === undefined || hour === null) {
      return null;
    }

    const hourString = `${hour}`;
    const normalizedHour =
      hourString.length === 5 ? `${hourString}:00` : hourString;

    return `${availableDate}T${normalizedHour}`;
  };

  const handleRescheduleSuccess = useCallback(
    async ({ sessionId, calendar }) => {
      setTypeMessage('success');
      setMessage('La reunión fue reagendada correctamente.');
      setReloadFlag((prev) => prev + 1);
      setIsLoading(true);

      const updateCollection = (collection) => {
        if (!Array.isArray(collection) || collection.length === 0) {
          return collection;
        }

        const nextStart = buildStartDateTime(
          calendar?.available_date,
          calendar?.hour || ''
        );

        return collection.map((session) => {
          if (session.id !== sessionId) {
            return session;
          }

          return {
            ...session,
            status: 'rescheduled',
            start: nextStart || session.start,
          };
        });
      };

      setAllSessions(updateCollection);
      setSessions(updateCollection);

      try {
        const params = {};
        if (searchTerm) {
          params.search = searchTerm;
        }
        params.page = currentPage;
        params.pageSize = pageSize;
        if (selectedClientId !== null) {
          params.clientId = selectedClientId;
        }
        if (selectedAnnouncementId !== null) {
          params.announcementId = selectedAnnouncementId;
        }

        const response = await SessionAPI.getSessions(params);
        const refreshedSessions = response?.data?.sessions || [];
        const refreshed = refreshedSessions.find(
          (session) => session.id === sessionId
        );

        if (refreshed) {
          setAllSessions((prev) =>
            (prev || []).map((session) =>
              session.id === sessionId ? refreshed : session
            )
          );
          setSessions((prev) =>
            (prev || []).map((session) =>
              session.id === sessionId ? refreshed : session
            )
          );
        }
      } catch (error) {
        // Best-effort refresh to sync meeting code after reschedule.
      } finally {
        setIsLoading(false);
      }
    },
    [
      setAllSessions,
      setSessions,
      buildStartDateTime,
      searchTerm,
      currentPage,
      pageSize,
      selectedClientId,
      selectedAnnouncementId,
    ]
  );

  const handleOpenRescheduleModal = useCallback(
    async (sessionId) => {
      if (isRescheduleLoading) {
        return;
      }

      setIsMenuOpen({ id: null, open: false });
      setIsRescheduleLoading(true);

      try {
        const sessionFromList = sessions.find(
          (session) => session.id === sessionId
        );
        const { data } = await SessionAPI.getDetailsSession(sessionId);
        const users = data?.users || [];

        const mentorUser = getUserByRole(users, 'mentor');
        const menteeUser = getUserByRole(users, 'mentee');

        const mentorId =
          mentorUser?.id ?? mentorUser?.user?.id ?? mentorUser?.userId ?? '';
        const menteeId =
          menteeUser?.id ?? menteeUser?.user?.id ?? menteeUser?.userId ?? '';

        if (!mentorId || !menteeId) {
          setTypeMessage('error');
          setMessage(
            'La reunión seleccionada no cuenta con participantes para reagendar.'
          );
          return;
        }

        const mentorName = mentorUser?.name ?? mentorUser?.user?.name ?? '';
        const menteeName = menteeUser?.name ?? menteeUser?.user?.name ?? '';

        const normalizedSession = {
          id: data?.id ?? sessionId,
          mentor: {
            id: mentorId,
            name: mentorName,
          },
          mentee: {
            id: menteeId,
            name: menteeName,
          },
          clientId:
            data?.clientId ??
            data?.client?.id ??
            sessionFromList?.clientId ??
            sessionFromList?.client?.id ??
            null,
          reason: data?.reason ?? '',
        };

        setSessionToReschedule(normalizedSession);
        setIsRescheduleModalOpen(true);
      } catch (error) {
        setTypeMessage('error');
        setMessage(
          error?.data?.message ||
            'No fue posible obtener los datos de la reunión.'
        );
      } finally {
        setIsRescheduleLoading(false);
      }
    },
    [sessions, isRescheduleLoading, getUserByRole]
  );

  const columns = React.useMemo(
    () => [
      {
        Header: 'Pilar',
        accessor: 'pillar.name',
      },
      {
        Header: function fnHeader() {
          return (
            <span
              id="change-status"
              ref={statusEl}
              onClick={() => {
                if (!showStatus) {
                  setShowStatus(true);
                }
              }}
            >
              Estado
              <Popover
                id="fade-menu"
                anchorEl={() => statusEl.current}
                open={showStatus}
                onClose={() => {
                  setShowStatus(false);
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <Box p={2} width="120px">
                  <MenuItem
                    style={{ placeContent: 'center' }}
                    onClick={() => {
                      setStatus(allStatus);
                    }}
                  >
                    Todos
                  </MenuItem>
                  {allStatus.map((value, index) => {
                    return (
                      <MenuItem
                        key={index}
                        style={{ placeContent: 'center' }}
                        onClick={() => {
                          setShowStatus(false);
                          setStatus([value]);
                        }}
                      >
                        {statusSession[value]}
                      </MenuItem>
                    );
                  })}
                </Box>
              </Popover>
            </span>
          );
        },
        id: 'status',
        accessor: function fnAccesor({ status }) {
          return statusSession[status];
        },
        Cell: ({value, row, column, updateMyData}) => {
          return (
            <EditableCell
              value={value}
              editValue={row.original.status}
              row={row}
              column={column}
              updateMyData={ async (rowIndex, columnId, newValue) => {
                await SessionAPI.updateSessionStatus(row.original.id, newValue)
                updateMyData(rowIndex, columnId, newValue)
                return { ok: true }
              }
              }
              editable={true}
              options={optionsStatus}
            />
          )
        },
        disableSortBy: true,
      },
      {
        Header: 'Fecha y hora',
        accessor: function fnAccesor({ start }) {
          return <p>{formatDate(start, 'DD/MM/YYYY HH:mm')}</p>;
        },
      },
      {
        Header: 'Programa Mentee',
        accessor: function fnAccesor({ users }) {
          return getRefererUser(users, 'mentee');
        },
      },
      {
        Header: 'Mentee',
        accessor: function fnAccesor({ users, space }) {
          const mentee = getUserByRole(users, 'mentee');

          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>{showUser(users, 'mentee')}</div>
              {Array.isArray(space) && space.length > 0 && mentee ? (
                <AttendanceIndicator user={mentee} />
              ) : null}
            </div>
          );
        },
      },
      {
        Header: 'Programa Mentor',
        accessor: function fnAccesor({ users }) {
          return getRefererUser(users, 'mentor');
        },
      },
      {
        Header: 'Mentor',
        accessor: function fnAccesor({ users, space }) {
          const mentor = getUserByRole(users, 'mentor');

          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>{showUser(users, 'mentor')}</div>
              {Array.isArray(space) && space.length > 0 && mentor ? (
                <AttendanceIndicator user={mentor} />
              ) : null}
            </div>
          );
        },
      },
      {
        Header: '',
        id: 'actions',
        accessor: function fnAccesor({ id, status, space }) {
          return (
            <MenuContainer onClick={() => onClick(id)}>
              {isMenuOpen.id === id && (
                <Menu
                  open={isMenuOpen.open}
                  items={[
                    {
                      text: 'Ver detalle',
                      action: () =>
                        history.push('/reuniones/detalle', {
                          idSession: id,
                        }),
                    },
                    {
                      text: 'Url de mentorí­a',
                      action: () => {
                        // if space is an array with length > 0, then define a code
                        const code = space.length > 0 ? space[0].code : '';
                        // url is defined from google meets if code exists and from url mentorias if not
                        const sessionUrl = code ? `https://meet.google.com/${code}` :  `${url}/mentorias/informacion?id=${id}`;
      
                        copyTextToClipboard(sessionUrl);
                      }
                    },
                    RESCHEDULABLE_STATUSES.includes(status) && {
                      text: 'Reagendar',
                      action: () => {
                        handleOpenRescheduleModal(id);
                      },
                    },
                    {
                      text: 'Agregar invitado',
                      action: () => {
                        setIsInvitationModalOpen(true);
                        setIdSession(id);
                      },
                    },
                    role &&
                      (role.type === 'admin' || role.type === 'manager') &&
                      ['created', 'not-assigned', 'no-email'].includes(
                        status
                      ) && {
                        text: 'Cancelar',
                        action: () => {
                          setSOpenModal(true);
                          setIdSession(id);
                        },
                      },
                  ]}
                />
              )}
            </MenuContainer>
          );
        },
        disableSortBy: true,
      },
    ],
    [
      history,
      showStatus,
      allStatus,
      role,
      showUser,
      isMenuOpen,
      handleOpenRescheduleModal,
      getRefererUser,
      getUserByRole,
    ]
  );

  return (
    <div className="user-container">
      {isRescheduleLoading && (
        <Spinner
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: 'rgba(255, 255, 255, 0.6)',
            zIndex: 1300,
          }}
        />
      )}
      {message && <Alert type={typeMessage}>{message}</Alert>}
      <Snackbar
        open={isClientSnackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseClientSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert onClose={handleCloseClientSnackbar} severity="info" elevation={6} variant="filled">
          {clientSnackbarMessage}
        </MuiAlert>
      </Snackbar>
      {openModal && (
        <Modal
          className={classes.modal}
          open={openModal}
          onClose={() => {
            setSOpenModal(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className="cancel-session">
            <h3>¿Estás seguro que deseas cancelar esta reunión?</h3>
            <Formik
              initialValues={{
                reason:
                  'Lo siento, no podré asistir a nuestra reunión. Gracias de todas formas',
              }}
              validationSchema={Yup.object({
                reason: Yup.string().required('Ingrese un motivo'),
              })}
              onSubmit={(values) => {
                handleCancelSession(values);
              }}
            >
              <Form>
                <div className="cancel__content">
                  <Input
                    label="Motivo"
                    placeholder="Motivo"
                    name="reason"
                    type="textarea"
                    max={500}
                    showCounter
                    isRequired={true}
                  />
                </div>
                <div className="info__button">
                  <div className="save-area">
                    <Grid container justify="space-around">
                      <Grid item xs={5}>
                        <Button
                          widthFull
                          secondary
                          onClick={() => {
                            setSOpenModal(false);
                          }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={5}>
                        <Button widthFull type="submit" loading={isSubmitting}>
                          Aceptar
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Form>
            </Formik>
          </div>
        </Modal>
      )}
      <InvitationModal
        open={isInvitationModalOpen}
        onClose={() => setIsInvitationModalOpen(false)}
        sessionId={idSession}
      />
      {isRescheduleModalOpen && sessionToReschedule && (
        <AnnouncementModal
          isOpen={isRescheduleModalOpen}
          onClose={() => {
            setIsRescheduleModalOpen(false);
            setSessionToReschedule(null);
          }}
          sessionData={sessionToReschedule}
          onRescheduleSuccess={handleRescheduleSuccess}
        />
      )}
      <Grid style={{ marginBottom: 24 }}>
        <SessionsDashboard />
      </Grid>
      <TableSite
        data={sessions}
        setData={handleSetSessions}
        columns={columns}
        isLoadingData={isLoading}
        tableName="Reuniones"
        defaultRowsPerPage={pageSize}
        onSearch={handleSearchSessions}
        isDynamic
        currentPage={currentPage}
        totalPages={totalPages}
        onChangePage={(event, newPageNumber) => {
          if (!Number.isFinite(newPageNumber)) {
            return;
          }
          setCurrentPage(Math.max(1, Number(newPageNumber)));
        }}
        filter={
          <Grid container spacing={2} style={{ marginTop: '16px', marginBottom: '16px', alignContent: 'end', alignItems: 'end', justifyContent: 'end' }}>
            <Grid item xs={12} md={7}>
              <Autocomplete
                options={clients}
                getOptionSelected={(option, value) =>
                  Boolean(option) && Boolean(value) && option.id === value.id
                }
                getOptionLabel={(option) => (option && option.name) || ''}
                value={selectedClient}
                onChange={handleClientChange}
                fullWidth
                clearOnEscape
                autoHighlight
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Cliente"
                    placeholder="Buscar cliente"
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Autocomplete
                options={announcements}
                getOptionSelected={(option, value) =>
                  Boolean(option) && Boolean(value) && option.id === value.id
                }
                getOptionLabel={(option) => (option && option.name) || ''}
                value={selectedAnnouncement}
                onChange={handleAnnouncementChange}
                fullWidth
                clearOnEscape
                autoHighlight
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Programa"
                    placeholder="Buscar programa"
                    size="small"
                  />
                )}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

export default SessionTableContainer;
